import { computed, Ref } from 'vue';
import { IFeedLeague } from '@/types';

export function useSearchedLeagueIds(search: Ref<string>, leagueItems: Ref<Record<number, IFeedLeague>>) {
    const searchedLeagueIds = computed<number[] | null>(() => {
        if (!search.value) {
            return null;
        }

        const searchLower = search.value.toLowerCase();
        const leagueIds: number[] = [];

        for (const id in leagueItems.value) {
            const league = leagueItems.value[id];
            if (league.name.toLowerCase().includes(searchLower)) {
                leagueIds.push(league.id);
            }
        }

        return leagueIds;
    });

    return { searchedLeagueIds };
}
